import Cookies from 'js-cookie'

import { changeLanguage } from '@/i18n/i18next-config'
import { LOCALE_COOKIE_NAME } from '@/config'
import { LanguagesSupported } from '@/i18n/language'

export const i18n = {
  defaultLocale: 'zh-Hans',
  locales: LanguagesSupported,
} as const

export type Locale = typeof i18n['locales'][number]

export const setLocaleOnClient = (locale: Locale, reloadPage = true) => {
  Cookies.set(LOCALE_COOKIE_NAME, locale)
  changeLanguage(locale)
  
  // 触发自定义事件通知Ant Design locale更新
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('languageChange'))
  }
  
  reloadPage && location.reload()
}

export const getLocaleOnClient = (): Locale => {
  const cookieLang = Cookies.get(LOCALE_COOKIE_NAME)
  const lang = cookieLang === 'zh-CN' ? 'zh-Hans' : (cookieLang === 'en' ? 'en-US' : cookieLang)
  return lang as Locale || i18n.defaultLocale
}
